import { render } from "./LeadEditDialog.vue?vue&type=template&id=9b774cd4"
import script from "./LeadEditDialog.vue?vue&type=script&lang=js"
export * from "./LeadEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__